import { render, staticRenderFns } from "./JurusanInput.vue?vue&type=template&id=428ef80e"
import script from "./JurusanInput.vue?vue&type=script&lang=js"
export * from "./JurusanInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428ef80e')) {
      api.createRecord('428ef80e', component.options)
    } else {
      api.reload('428ef80e', component.options)
    }
    module.hot.accept("./JurusanInput.vue?vue&type=template&id=428ef80e", function () {
      api.rerender('428ef80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/helper/JurusanInput.vue"
export default component.exports